module.exports = ".report-container {\n  display: inline-block;\n  margin: 0;\n  width: 100%; }\n  .report-container:hover {\n    background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(70%, #fff));\n    background: linear-gradient(to bottom, transparent 0%, #fff 70%); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/status/report-status.component.scss
// module id = ./src/app/report/components/status/report-status.component.scss
// module chunks = main